import React from "react"
import { Container, Grid, Typography } from "@mui/material"
import Loader from "@/shared/components/loader"
import { useProfileData } from "@/features/profile/hooks/useProfileData"
import ProfileInfoCard from "@/features/profile/components/ProfileInfoCard"
import CreditCard from "@/features/profile/components/CreditCard"
import UsageCard from "@/features/profile/components/UsageCard"
import TransactionHistoryCard from "@/features/profile/components/TransactionHistoryCard"

const ProfilePage: React.FC = () => {
  const {
    displayName,
    email,
    photoURL,
    memberSince,
    creditsRemaining,
    creditsUsed,
    creditsPurchased,
    productsThisMonth,
    isLoading
  } = useProfileData()

  if (isLoading) return <Loader />

  return (
    <Container maxWidth="md" sx={{ pb: 10 }}>
      <Typography variant="h5" fontWeight={700} mb={3}>
        My Profile
      </Typography>

      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12} md={6} sx={{ display: "flex" }}>
          <ProfileInfoCard displayName={displayName} email={email} photoURL={photoURL} memberSince={memberSince} />
        </Grid>

        <Grid item xs={12} md={6} sx={{ display: "flex" }}>
          <CreditCard
            creditsRemaining={creditsRemaining}
            creditsUsed={creditsUsed}
            creditsPurchased={creditsPurchased}
          />
        </Grid>

        <Grid item xs={12} md={6} sx={{ display: "flex" }}>
          <UsageCard productsThisMonth={productsThisMonth} creditsRemaining={creditsRemaining} />
        </Grid>

        <Grid item xs={12}>
          <TransactionHistoryCard />
        </Grid>
      </Grid>
    </Container>
  )
}

export default ProfilePage
